import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNearme(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.146 2.738a.95.95 0 0 1 1.074 1.254L15.19 20.82c-.392 1.092-1.933 1.098-2.335.01l-2.57-6.978a.23.23 0 0 0-.14-.139l-6.978-2.571c-1.088-.401-1.082-1.943.01-2.334l16.828-6.03zM4.352 9.98l6.312 2.326c.476.175.852.55 1.027 1.027l2.326 6.312 5.397-15.063z"
  }));
}
var IcNearme = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNearme));

export { IcNearme as I };
